module.exports = __webpack_public_path__ + "img/logout.2df21551.png";